import { ReactElement } from "react";
import { ICranes, IPanelProps } from "./types";
import RowComponent from "../../components/rowComponent";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import TextField from "@mui/material/TextField";
import { cloneObject } from "../../../../system/utils";

const CranesPanel = ({ value, property, onChange }: IPanelProps<ICranes>): ReactElement => {

  const onChangeValue = (prop: keyof ICranes, selectedValue: any) => {
    const newValue = cloneObject(value);

    newValue[prop].value = selectedValue;
    onChange(property, newValue);
  };

  const onChangeComment = (prop: keyof ICranes, comment: string) => {
    const newValue = cloneObject(value);

    newValue[prop].comment = comment;
    onChange(property, newValue);
  };

  return (
    <div className="display-flex-column gap-1 p-1">
      <RowComponent title="B3" ratio={.2} >
        <div className="row-content-2">
          <ToggleButtonGroup
            fullWidth={true}
            value={value.b3.value}
            exclusive={true}
            onChange={(_event, selectedValue) => onChangeValue("b3", selectedValue)}>
            <ToggleButton value={true} >OK</ToggleButton>
            <ToggleButton value={false} >NOT OK</ToggleButton>
          </ToggleButtonGroup>
          <TextField
            variant="outlined"
            placeholder="to be filled..."
            multiline={true}
            minRows={4}
            maxRows={4}
            value = {value.b3.comment}
            fullWidth={true}
            onChange={event => onChangeComment("b3", event.target.value)}
          />
        </div>
      </RowComponent>
      <RowComponent title="C1/C2" ratio={.2} >
        <div className="row-content-2">
          <ToggleButtonGroup
            fullWidth={true}
            value={value.c1_c2.value}
            exclusive={true}
            onChange={(_event, selectedValue) => onChangeValue("c1_c2", selectedValue)}>
            <ToggleButton value={true} >OK</ToggleButton>
            <ToggleButton value={false} >NOT OK</ToggleButton>
          </ToggleButtonGroup>
          <TextField
            variant="outlined"
            placeholder="to be filled..."
            multiline={true}
            minRows={4}
            maxRows={4}
            value = {value.c1_c2.comment}
            fullWidth={true}
            onChange={event => onChangeComment("c1_c2", event.target.value)}
          />
        </div>
      </RowComponent>
      <RowComponent title="E1/E3" ratio={.2} >
        <div className="row-content-2">
          <ToggleButtonGroup
            fullWidth={true}
            value={value.e1_e3.value}
            exclusive={true}
            onChange={(_event, selectedValue) => onChangeValue("e1_e3", selectedValue)}>
            <ToggleButton value={true} >OK</ToggleButton>
            <ToggleButton value={false} >NOT OK</ToggleButton>
          </ToggleButtonGroup>
          <TextField
            variant="outlined"
            placeholder="to be filled..."
            multiline={true}
            minRows={4}
            maxRows={4}
            value = {value.e1_e3.comment}
            fullWidth={true}
            onChange={event => onChangeComment("e1_e3", event.target.value)}
          />
        </div>
      </RowComponent>
      <RowComponent title="Casey/C&M" ratio={.2} >
        <div className="row-content-2">
          <ToggleButtonGroup
            fullWidth={true}
            value={value.casey_CM.value}
            exclusive={true}
            onChange={(_event, selectedValue) => onChangeValue("casey_CM", selectedValue)}>
            <ToggleButton value={true} >OK</ToggleButton>
            <ToggleButton value={false} >NOT OK</ToggleButton>
          </ToggleButtonGroup>
          <TextField
            variant="outlined"
            placeholder="to be filled..."
            multiline={true}
            minRows={4}
            maxRows={4}
            value = {value.casey_CM.comment}
            fullWidth={true}
            onChange={event => onChangeComment("casey_CM", event.target.value)}
          />
        </div>
      </RowComponent>
    </div>
  );
};

export default CranesPanel;